import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasCreated.meta';
import { type EditInCanvasOpenedAction } from './useTrackEditInCanvasOpened.meta';

export type UseTrackCanvasCreatedParams = {
  canvas_id: string;
  library_id?: string;
  board_id?: string;
  source?:
    | 'board'
    | 'board_tile'
    | 'empty_board_cta'
    | 'library'
    | 'general_library'
    | 'asset_selection_bar'
    | 'all_content_header'
    | 'canvases'
    | 'board_canvas_open'
    | 'all_content_canvas_open'
    | 'edit_mode_panel'
    | 'asset_context_menu'
    | 'asset_modal_quick_tools'
    | 'asset_modal_versions_menu'
    | 'asset_modal_video_editor'
    | 'board_context_menu'
    | 'asset_hover'
    | 'asset_multi_select'
    | 'recent_canvases'
    | 'announcement'
    | 'marketing_url';
  type?: 'floating_action' | 'graduated';
  edit_in_canvas_action?: EditInCanvasOpenedAction;
  announcement_id?: string;
};

export const useTrackCanvasCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasCreated = useCallback(
    (params: UseTrackCanvasCreatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasCreated };
};
